module.exports = __webpack_public_path__ + "static/img/th.29b0aa03.svg";